/**
 * This custom hook provides the functionality to retrieve users to be shown in the UI.
 */

import {useContext} from "react";
import {FirebaseAuthContext} from "../../../../commons/firebase/FirebaseAuthProvider";
import {useSnackbar} from "notistack";
import {useIntl} from "react-intl";

const useFetchChartData = () => {

    const {signedInUser} = useContext(FirebaseAuthContext);
    const {enqueueSnackbar} = useSnackbar();

    // Internationalization for simple strings
    const intl = useIntl();

    // Retrieving the playlists and setting the list in the state variable
    const fetchChartData = async (associationsFilter,
                                   disciplinesFilter,
                                   coursesFilter,
                                   playlistsFilter,
                                   usersFilter,
                                   expertisesFilter,
                                   difficultiesFilter,
                                   fromDate,
                                   toDate,
                                   metric,
                                   aggregation,
                                   chartType) => {

        const idToken = await signedInUser.getIdToken()

        // Prepare the dates in UTC timestamp, so that they are comparable globally
        let fromDateBeginOfDay = new Date(Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), 0, 0, 0, 0))
        let toDateEndOfDay = new Date(Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), 23, 59, 59, 999))

        return fetch('/reg-main/statistics/admin' +
            '?idToken=' + idToken +
            '&associationsFilter=' + JSON.stringify(associationsFilter.map(o => o.id)) +
            '&disciplinesFilter=' + JSON.stringify(disciplinesFilter.map(o => o.id)) +
            '&coursesFilter=' + JSON.stringify(coursesFilter.map(o => o.id)) +
            '&playlistsFilter=' + JSON.stringify(playlistsFilter.map(o => o.id)) +
            '&usersFilter=' + JSON.stringify(usersFilter.map(o => o.id)) +
            '&expertisesFilter=' + JSON.stringify(expertisesFilter.map(o => o.id)) +
            '&difficultiesFilter=' + JSON.stringify(difficultiesFilter.map(o => o.id)) +
            '&fromDate=' + JSON.stringify(fromDateBeginOfDay) +
            '&toDate=' + JSON.stringify(toDateEndOfDay) +
            '&metric=' + JSON.stringify(metric) +
            '&aggregation=' + JSON.stringify(aggregation) +
            '&chartType=' + JSON.stringify(chartType)
        ).then(async (data) => {
            // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
            if (data.status !== 200) {
                throw new Error((await data.json()).status)
            }

            return data.json();
        }).catch((error) => {
            enqueueSnackbar(
                intl.formatMessage({
                    id: 'app.statistics.messages.load.chartData.error',
                    defaultMessage: 'Something went wrong while loading the chart data: {error}'
                }, {error: error.message}), {
                    variant: 'error',
                    preventDuplicate: true,
                    autoHideDuration: 5000
                });
        })

    }

    return {
        fetchChartData
    }
}
export default useFetchChartData;